import { FC } from 'react'
import { Box, TextField, Typography, Button, Modal } from '@mui/material'
import { WalletCardModalProps } from './WalletCardModal.types'
import { useWalletCardModal } from './WalletCardModal.logic'
import './WalletCardModal.scss'

const WalletCardModal: FC<WalletCardModalProps> = (props) => {
  const { open, onClose } = props
  const {
    formData,
    errors,
    isSubmitting,
    surgeryLoading,
    handleChange,
    handleSubmit,
  } = useWalletCardModal(props)

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="wallet-card-modal"
      aria-labelledby="wallet-card-modal-title"
      aria-describedby="wallet-card-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '500px', md: '600px' },
          maxWidth: 'md',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 3,
          borderRadius: 1,
          outline: 'none',
        }}
      >
        <Typography id="wallet-card-modal-title" variant="h3" gutterBottom>
          Send Wallet Card
        </Typography>

        <Typography
          id="wallet-card-modal-description"
          variant="body1"
          sx={{ mb: 3 }}
        >
          Enter patient information to send a wallet card
        </Typography>

        <Box className="wallet-card-form" sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <TextField
              label="First Name"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.firstName}
              helperText={errors.firstName}
              disabled={isSubmitting}
              placeholder="First name"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Last Name"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              fullWidth
              required
              error={!!errors.lastName}
              helperText={errors.lastName}
              disabled={isSubmitting}
              placeholder="Last name"
              InputLabelProps={{ shrink: true }}
            />
          </Box>

          <TextField
            label="Email Address"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
            error={!!errors.email}
            helperText={errors.email}
            disabled={isSubmitting}
            placeholder="Patient's email address"
            InputLabelProps={{ shrink: true }}
            sx={{ mb: 2 }}
          />

          <TextField
            label="Phone Number"
            name="phoneNumber"
            type="tel"
            value={formData.phoneNumber}
            onChange={handleChange}
            fullWidth
            placeholder="(XXX) XXX-XXXX"
            error={!!errors.phoneNumber}
            helperText={
              errors.phoneNumber ||
              (formData.phoneNumber &&
              formData.phoneNumber.length > 0 &&
              formData.phoneNumber.length < 14
                ? 'Complete phone number required'
                : '')
            }
            disabled={isSubmitting}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              pattern: '\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}',
              title: 'Phone number format: (XXX) XXX-XXXX',
            }}
          />
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button variant="outlined" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={isSubmitting || surgeryLoading}
            color="primary"
          >
            {isSubmitting ? 'Sending...' : 'Send'}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default WalletCardModal
